<template>
  <div class="row justify-content-center" style="padding-bottom: 20px;">
    <div class="col-lg-6 mt-2">
      <idx-card :title="`${this.$t('menu.settings.integrations.name')}`">
        <div class="row">
          <div class="col-12">
            <b-tabs content-class="mt-3">
              <b-tab
                active
                :title="`${this.$t('menu.settings.integrations.titleZenvia')}`"
              >
                <zenvia />
                <GoBackButton />
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </idx-card>
    </div>
  </div>
</template>
<script>
import IdxCard from '@/components/molecules/idx-card';
import Zenvia from '@/components/molecules/zenvia';
import GoBackButton from '../../../../atoms/goback-button';

export default {
  name: 'Integrations',

  data() {
    return {
      userAuth: null,
    };
  },

  components: {
    IdxCard,
    Zenvia,
    GoBackButton,
  },

  computed: {},

  methods: {},

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style>
.row.justify-content-center {
  background: #fff;
}

/* .idx-card {
  margin-top: 30px;
  margin-bottom: 30px;
} */
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/integrations-webhooks/integration-zeenvia/index.vue